export function cell(e) {
  e.currentTarget.maxLength = 16;
  let val = e.currentTarget.value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{1})(\d{4})(\d)/, '$1 $2-$3')
    .replace(/(-\d{4})(\d+?)$/, '$1');

  e.currentTarget.value = val;
}

export function cellMask(str) {
  let val = str
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{1})(\d{4})(\d)/, '$1$2-$3')
    .replace(/(-\d{4})(\d+?)$/, '$1');

  return val;
}

export function formatBRL(value) {

  const m = value
  if (!value) return "";
  // Remove tudo que não for número
  const numeric = value.toString().replace(/\D/g, "");

  // Divide por 100 para considerar centavos
  const number = Number(numeric) / 100;
  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}


export function number(e) {
  let value = e.currentTarget.value;

  value = value.replace(/\D/g, '');

  e.currentTarget.value = value;
}

export function validatePassword(eventOrValue) {
  // /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/

  //   /^
  //   (?=.*\d)              // deve conter ao menos um dígito
  //   (?=.*[a-z])           // deve conter ao menos uma letra minúscula
  //   (?=.*[A-Z])           // deve conter ao menos uma letra maiúscula
  //   (?=.*[$*&@#])         // deve conter ao menos um caractere especial
  //   [0-9a-zA-Z$*&@#]{8,}  // deve conter ao menos 8 dos caracteres mencionados
  // $/
  let value = eventOrValue?.currentTarget?.value ?? eventOrValue;

  if (!value) {
    return true;
  }

  return /^(?=.*\d)(?=.*[A-Z])[0-9a-zA-Z$*&@#]{8,}$/.test(value);
}

export function cpf(e) {
  let val = e.currentTarget.value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2') // pega 3 primeiros e o restante 000.
    .replace(/(\d{3})(\d)/, '$1.$2') // pega 3 primeiros e o restante 000.000.
    .replace(/(\d{3})(\d{1,2})/, '$1-$2') // pega 3 e no segundo só aceita 2 digitos separados por um hifen
    .replace(/(-\d{2})\d+?$/, '$1');

  return val;
}

export function cpfMask(value) {
  let val = value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2') // pega 3 primeiros e o restante 000.
    .replace(/(\d{3})(\d)/, '$1.$2') // pega 3 primeiros e o restante 000.000.
    .replace(/(\d{3})(\d{1,2})/, '$1-$2') // pega 3 e no segundo só aceita 2 digitos separados por um hifen
    .replace(/(-\d{2})\d+?$/, '$1');

  return val;
}

export function cepMask(value) {
  let cep = value;
  cep = cep.replace(/\D/g, '');
  cep = cep.replace(/(\d{5})(\d{1,3})$/, '$1-$2');

  return cep;
}

export function cnpj(e) {
  // 99.999.999/9999-99
  e.currentTarget.maxLength = 18;
  let val = e.currentTarget.value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
  // .replace(/(-\d{2})\d+?$/, "$1-$2");

  return val;
}

export function cnpjMask(value) {
  try {
    let val = value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2');
    // .replace(/(-\d{2})\d+?$/, "$1-$2");
  
    return val;
  } catch (error) {
    return '';
  }
}

export function validateCPF(strCPF) {
  strCPF = strCPF.replace(/\D/g, '');

  if (
    strCPF.length != 11 ||
    strCPF == '00000000000' ||
    strCPF == '11111111111' ||
    strCPF == '22222222222' ||
    strCPF == '33333333333' ||
    strCPF == '44444444444' ||
    strCPF == '55555555555' ||
    strCPF == '66666666666' ||
    strCPF == '77777777777' ||
    strCPF == '88888888888' ||
    strCPF == '99999999999'
  )
    return false;

  var Soma;
  var Resto;
  Soma = 0;
  if (strCPF == '00000000000') return false;

  for (var i = 1; i <= 9; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(9, 10))) return false;

  Soma = 0;
  for (i = 1; i <= 10; i++)
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  Resto = (Soma * 10) % 11;

  if (Resto == 10 || Resto == 11) Resto = 0;
  if (Resto != parseInt(strCPF.substring(10, 11))) return false;
  return true;
}

export function validateCnpj(strCnpj) {
  //https://www.geradorcnpj.com/javascript-validar-cnpj.htm#:~:text=Esta%20verificação%20é%20necessária%20uma,com%20o%20algoritmo%20do%20CNPJ.

  strCnpj = strCnpj.replace(/\D/g, '');

  if (strCnpj === '') return false;

  if (strCnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    strCnpj == '00000000000000' ||
    strCnpj == '11111111111111' ||
    strCnpj == '22222222222222' ||
    strCnpj == '33333333333333' ||
    strCnpj == '44444444444444' ||
    strCnpj == '55555555555555' ||
    strCnpj == '66666666666666' ||
    strCnpj == '77777777777777' ||
    strCnpj == '88888888888888' ||
    strCnpj == '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho = strCnpj.length - 2;
  let numeros = strCnpj.substring(0, tamanho);
  let digitos = strCnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = strCnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

// Protege o email: joao@gmail.com -> +- jo***@gmail.com
export function emailMask(email) {
  var maskedEmail = email.replace(/([^@\.])/g, '*').split('');
  var previous = '';
  const length = maskedEmail.length;
  for (var i = 0; i < length; i++) {
    if (i < 2 || previous == '.' || previous == '@') {
      maskedEmail[i] = email[i];
    }
    previous = email[i];
  }
  return maskedEmail.join('');
}
